import React, {useEffect, useMemo, useState} from 'react';
import PassportYearsTab from "./PassportYearsTab";
import useAPI from "../../../../hooks/useAPI";
import useUserContext from "../../../../hooks/useUserContext";
import useToast from "../../../../hooks/useToast";
import {closeYearForType, changePeriodFieldState, getPeriodsData, getPeriodsFields} from "../../../../requests/exportRequests";
import style from "../style.module.less";
import StatusBadge from "../../../../components/common/StatusBadge";
import {Form} from "react-bootstrap";
import MaterialTable from "material-table";
import {modifyDefaultOptions, objectToCols} from "../../../../helpers/table";
import { render } from 'less';

const styledHeading = {
    marginLeft: 0, marginBottom: 24, marginTop: 24, color: 'rgba(0, 0, 0, 0.87)',
};
const currentYear = new Date().getFullYear();

const BaseYearsTabs = ({type, header}) => {
    const api = useAPI();
    const userCtx = useUserContext();
    const addToast = useToast();
    const [choiceIncluded, setChoiceIncluded] = useState();
    const [yearSet, setYearSet] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const data = await type === 'periodFields' ? getPeriodsFields(api) : getPeriodsData(api, type);
            return data;
        };
        fetchData().then((result) => {
            setYearSet(result); 
            type === 'periodFields' && setChoiceIncluded(!!!result.find((e) => e.isCurrent))
        });
    }, [api]);

    const columns = [
        {
            title: 'Статус',
            field: 'isClosed',
            render: (rowData) => (
                <div className={style.wrapperBadge}>
                    <StatusBadge
                        height={26}
                        type={type === 'periodFields' ? "reportPeriods" : "resultPeriods"}
                        status={type === 'periodFields' ? rowData.isCurrent ? 'opened' : 'closed' : rowData.isClosed ? 'closed' : 'opened'}
                    />
                </div>
            ),
            width: '150px',
        },
        {
            title: 'Наименование периода',
            field: type === 'periodFields' ? 'title' : 'year',
            minWidth: '260px',
            render: rowData => {
                if(type === 'periodFields'){
                    const year = rowData.code === 'fact' ? currentYear - 1 : currentYear;
                    return [rowData.title, year].join(rowData.title.endsWith('.') ? '' : ' ');
                }
                return rowData.year
            }
        },
        {
            title: 'Автор действия',
            render: (rowData) => (
                <span>{rowData?.updatedBy?.displayName ? rowData?.updatedBy?.displayName : '—'}</span>
            ),
            minWidth: '170px',
        },
        // Temporary gap
        {
            render: (rowData) => <div />,
            minWidth: '550px',
        },
        {
            headerStyle: {
                fontSize: '16px',
                textAlign: 'center',
            },
            minWidth: '170px',
            title: 'Закрыть / Открыть',
            render: (rowData) => (
                <Form.Check
                    className={style.switchSettings}
                    onChange={() => {
                        const current = type === 'periodFields' ? yearSet.filter((x) => rowData.code === x.code)[0] : yearSet.filter((x) => rowData.year === x.year)[0];
                        return type === 'periodFields' ? 
                        changePeriodFieldState(api, rowData.code, addToast, !current.isCurrent)
                            .then((x) => {
                                const copy = [...yearSet.map((val) => (val.code === x?.code ? x : val))];
                                setYearSet(copy);
                                setChoiceIncluded(!!!copy.find((e) => e.isCurrent))
                            })
                        :
                        closeYearForType(api, type, rowData.year, addToast, !current.isClosed)
                            .then((x) => {
                                const copy = [...yearSet.map((val) => (val.id === x?.id ? x : val))];
                                setYearSet(copy);
                            })
                    }}
                    type="switch"
                    id="custom-switch"
                    label=""
                    checked={type === 'periodFields' ? rowData.isCurrent : !rowData.isClosed}
                    disabled={type === 'periodFields' && !rowData.isCurrent && !choiceIncluded }
                />
            ),
        },

    ];

    const settingsTable = useMemo(() => (
        <div className={style.settingsTable}>
            <MaterialTable
                columns={objectToCols(columns)}
                data={yearSet}
                options={modifyDefaultOptions({
                    width: 'auto',
                    padding: 'default',
                    filtering: false,
                    sorting: false,
                    search: false,
                    toolbar: false,
                    rowStyle: (rowData) => ({
                        backgroundColor: '#FFF',
                    }),
                    cellStyle: {
                        borderBottom: '#000 1px solid',
                    },
                    headerStyle: {
                        fontSize: '16px',
                        borderBottom: '#000 1px solid',
                        lineHeight: 1.3,
                        // height:50,
                        zIndex: 0,

                    },
                })}
            />
        </div>
    ), [yearSet, columns]);

    return (
        <div style={{ marginTop: 32, maxWidth: '100%' }}>
            <h3 style={styledHeading}>{header}</h3>
            <div style={{ marginTop: 20 }}>
                {/* <Element> */}
                {/*    <SettingsCard */}
                {/*        headerCardText={"Настройки для паспорта"} */}
                {/*        headerModalText={"Какой год вы бы хотели удалить из списка при выборе"} */}
                {/*        enabled={isAdmin(userCtx)} */}
                {/*        api={api} */}
                {/*        type={'passport'} */}
                {/*        addToast={addToast} */}
                {/*    /> */}
                {/* </Element> */}
                {settingsTable}
            </div>
        </div>
    );
};

export default BaseYearsTabs;